import Banner from '../../../sections/common/banner';
import SectionSidebar from '../../../sections/sidebar/section-sidebar';
import { data } from '../../../../globals/data/services-detail';
import { data as serviceData } from '../../../../globals/data/global-services';
import SectionServiceContent from '../../../sections/services/section-service-content';
import SectionBookService from '../../../sections/services/section-book-service';
import ServicesPageHelmet from '../../../helmets/ServicesPageHelmet';

const service = 'Distribution Solutions';

export default function DistributionSolutions() {
  return (
    <>
      <ServicesPageHelmet />

      <Banner _data={{ ...data.banner, crumb: service }} />

      <div className='section-full p-t120 p-b90 bg-white'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-8 col-md-12'>
              <div className='service-full-info'>
                <div className='services-etc m-b30'>
                  <div className='mb-4'>
                    <SectionServiceContent
                      service={service}
                      _data={serviceData?.serviceDetails?.distributionSolutions}
                    />
                  </div>
                  <SectionBookService />
                </div>
              </div>
            </div>
            <div className='col-lg-4 col-md-12 rightSidebar side-bar'>
              <SectionSidebar />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
